import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppSaveService } from './app-save.service';

@Component({
  selector: 'sd-app-save',
  templateUrl: './app-save.component.html',
  styleUrls: ['./app-save.component.scss']
})
export class AppSaveComponent implements OnInit, OnDestroy {
  isSaving$ = this.appSaveService.isSaving$;

  constructor(readonly appSaveService: AppSaveService) {}

  ngOnInit() {}

  ngOnDestroy() {}

  executeFunc() {
    this.appSaveService.exeSave();
  }

  runFormValidationSummary() {
    this.appSaveService.validateForm();
  }
}
